import { render, staticRenderFns } from "./ThePreviewNavBar.vue?vue&type=template&id=1245dc1a&scoped=true&"
import script from "./ThePreviewNavBar.vue?vue&type=script&lang=ts&"
export * from "./ThePreviewNavBar.vue?vue&type=script&lang=ts&"
import style0 from "./ThePreviewNavBar.vue?vue&type=style&index=0&id=1245dc1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1245dc1a",
  null
  
)

export default component.exports